import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fdc7a9c2")
const _hoisted_1 = { class: "bg-gray-50" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, "Checkout", -1)
const _hoisted_4 = { class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Contact information", -1)
const _hoisted_6 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-sm font-medium text-gray-700"
}, "First name", -1)
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "Last name", -1)
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "block text-sm font-medium text-gray-700"
}, "Email address", -1)
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "sm:col-span-2 mt-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, "Phone", -1)
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "activationDateOption",
  class: "block text-sm font-medium text-gray-700"
}, "Service activation date", -1)
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: false }, "ASAP", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Pick a Date", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "activationDate",
  class: "block text-sm font-medium text-gray-700"
}, "Confirm service activation date", -1)
const _hoisted_30 = { class: "mt-1" }
const _hoisted_31 = ["min"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "mt-6 flex space-x-2" }
const _hoisted_34 = { class: "flex items-center h-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "same-as-shipping",
  class: "text-sm font-medium text-gray-900"
}, "Is this a business account?", -1)
const _hoisted_36 = {
  key: 0,
  class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  for: "company-name",
  class: "block text-sm font-medium text-gray-700"
}, "Company name", -1)
const _hoisted_38 = { class: "mt-1" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "abn-number",
  class: "block text-sm font-medium text-gray-700"
}, "ABN Number", -1)
const _hoisted_41 = { class: "mt-1" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "mt-10 border-t border-gray-200 pt-10" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Payment Method", -1)
const _hoisted_45 = {
  key: 0,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4"
}
const _hoisted_46 = { class: "col-span-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  for: "card-number",
  class: "block text-sm font-medium text-gray-700"
}, "Card number", -1)
const _hoisted_48 = { class: "mt-1" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "col-span-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "name-on-card",
  class: "block text-sm font-medium text-gray-700"
}, "Name on card", -1)
const _hoisted_52 = { class: "mt-1" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "col-span-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  for: "expiration-date",
  class: "block text-sm font-medium text-gray-700"
}, "Expiration date (MM/YY)", -1)
const _hoisted_56 = { class: "mt-1" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  for: "cvc",
  class: "block text-sm font-medium text-gray-700"
}, "CVC", -1)
const _hoisted_59 = { class: "mt-1" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 1,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4"
}
const _hoisted_62 = { class: "col-span-3" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "account-number",
  class: "block text-sm font-medium text-gray-700"
}, "Account Number", -1)
const _hoisted_64 = { class: "mt-1" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", {
  for: "bsb",
  class: "block text-sm font-medium text-gray-700"
}, "BSB", -1)
const _hoisted_67 = { class: "mt-1" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "mt-10 lg:mt-0" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Confirm Details", -1)
const _hoisted_71 = { class: "" }
const _hoisted_72 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_73 = { class: "py-6 px-4 space-y-6 sm:px-6" }
const _hoisted_74 = { class: "flex justify-between items-center" }
const _hoisted_75 = { class: "" }
const _hoisted_76 = { class: "min-w-0 flex-1" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-brand-secondary font-light" }, " Confirm your service address below. ", -1)
const _hoisted_78 = { class: "mt-1 text-lg" }
const _hoisted_79 = { class: "text-base font-medium text-gray-900" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-gray-400",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-brand-accent",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "flex items-center justify-between border-t border-gray-200 pt-6" }
const _hoisted_86 = { class: "text-sm font-light pr-6" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode(" I have read, understood and accept the ")
const _hoisted_88 = ["href"]
const _hoisted_89 = { class: "text-base font-medium text-gray-900" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-gray-400",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-brand-accent",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_96 = /*#__PURE__*/_createTextVNode(" I have read, understood and accept the ")
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", { class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250" }, "CSG waiver.", -1)
const _hoisted_98 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_99 = /*#__PURE__*/_createTextVNode("Ensure you have read the ")
const _hoisted_100 = ["href"]
const _hoisted_101 = { class: "text-base font-medium text-gray-900" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-gray-400",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-brand-accent",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_108 = { class: "text-sm font-light h-64 overflow-hidden" }
const _hoisted_109 = { class: "flex items-center justify-between border-t border-gray-200 pt-6" }
const _hoisted_110 = { class: "text-sm font-light pr-6" }
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" I have read, understood and accept the ")
const _hoisted_112 = ["href"]
const _hoisted_113 = { class: "text-base font-medium text-gray-900" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Use setting", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-gray-400",
  fill: "none",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-3 w-3 text-brand-accent",
  fill: "currentColor",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
], -1)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-9 text-lg font-medium text-gray-900" }, "Promotions", -1)
const _hoisted_120 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("h3", { class: "sr-only" }, "Enter promotion code here", -1)
const _hoisted_122 = { class: "min-w-0 flex-1 p-4" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", {
  for: "promoCode",
  class: "block text-sm font-medium text-gray-700 pb-1"
}, "Enter promotion code", -1)
const _hoisted_124 = {
  key: 0,
  class: "mt-1 font-normal text-sm text-green-500"
}
const _hoisted_125 = {
  key: 1,
  class: "mt-1 font-normal text-sm text-red-500"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-9 text-lg font-medium text-gray-900" }, "Order summary", -1)
const _hoisted_127 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("h3", { class: "sr-only" }, "Items in your cart", -1)
const _hoisted_129 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_130 = { class: "" }
const _hoisted_131 = { class: "min-w-0 flex-1" }
const _hoisted_132 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_133 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_134 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_135 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_136 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_137 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_138 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_139 = { class: "border-t border-gray-200 pb-6" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm py-6" }, " Activation Fee ", -1)
const _hoisted_141 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_142 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_143 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_144 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_145 = { class: "text-sm pb-4" }
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" New Development Fee ")
const _hoisted_147 = { class: "tooltip" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tooltipmsg" }, "The New Development Charge or NDC is a charge that is passed on from the network wholesale provider to residents via the Retail Service Provider. This fee is applied to all new developments as a one-time fee for the first user to activate an internet service.")
], -1)
const _hoisted_149 = { class: "ml-6 flex-1 flex flex-col pb-4" }
const _hoisted_150 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_151 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_152 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_153 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_154 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm font-extralight" }, " The new development fee of $300 will be applied in month 13 ", -1)
const _hoisted_155 = [
  _hoisted_154
]
const _hoisted_156 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_157 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm font-extralight" }, " First Year Free! - Standard billing will commence in month 13 ", -1)
const _hoisted_158 = [
  _hoisted_157
]
const _hoisted_159 = {
  key: 2,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_160 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm font-extralight" }, " First Month Free! ", -1)
const _hoisted_161 = [
  _hoisted_160
]
const _hoisted_162 = {
  key: 3,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_163 = /*#__PURE__*/_createElementVNode("dt", { class: "text-sm font-extralight" }, " Pre-Installed router ", -1)
const _hoisted_164 = [
  _hoisted_163
]
const _hoisted_165 = { class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("dt", { class: "text-base font-medium" }, " First Invoice Total ", -1)
const _hoisted_167 = { class: "text-base font-medium text-gray-900" }
const _hoisted_168 = { class: "flex items-center justify-between px-4 sm:px-6" }
const _hoisted_169 = { class: "text-sm font-extralight" }
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" The total minimum cost of service over duration of the contract selected less any discounts is ")
const _hoisted_171 = { class: "font-medium" }
const _hoisted_172 = { class: "border-t border-gray-200 py-6 px-4 sm:px-6" }
const _hoisted_173 = { class: "pb-4" }
const _hoisted_174 = /*#__PURE__*/_createTextVNode("Confirm Order")
const _hoisted_175 = {
  key: 0,
  class: "mt-4 text-sm text-red-600"
}
const _hoisted_176 = {
  key: 1,
  class: "mt-4 text-sm text-red-600"
}
_popScopeId()

import { computed, reactive, ref, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { helpers, email, required, requiredIf, minLength, maxLength, integer } from '@vuelidate/validators';
import { ccValidations } from '@/validations/ccValidations';
import { nameValidations } from '@/validations/nameValidations';
import { OrderServiceInterface } from '@/services/orderServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Product } from '@/adapters/catalogAdapterInterface';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import AsyncButton from '../library/AsyncButton.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import format from 'date-fns/format';
import addDays from 'date-fns/fp/addDays';
import store from '@/store';
import { InformationCircleIcon } from '@heroicons/vue/outline';
import { RecaptchaV2, useRecaptcha } from 'vue3-recaptcha-v2';

// Adding this prevents Vue warnings
import { Switch } from '@headlessui/vue';
import { Action, Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';
import CsgTerms from '@/components/content/CsgTerms.vue';

export type ContactInformation = {
  firstName: string | null,
  lastName: string | null,
  phoneNumber: string | null,
  email: string
};

type Service = {
  id: string,
  address: string,
  carrier: string,
  locationId: string,
  requiresNewDevelopmentCost: boolean,
  development: string,
  suburb: string,
  state: string,
  rtcDays: number,
}

type ConfirmOrderData = {
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: number | null,
  companyName: string,
  abnNumber: number | null,
  ccNumber: number | null,
  ccName: string,
  ccExpiry: string,
  ccCvc: string,
  ddAccountNumber: string,
  ddAccountBsb: string,
  token?: string,
  activationDate: string,
  formSelectionOptions: {
    businessAccount: boolean,
    paymentMethod: string,
    confirmAddressToggle: boolean,
    termsAgreementToggle: boolean,
    csgWaiverToggle: boolean,
    toggleExpandCsgWaiver: boolean,
    ddAgreementToggle: boolean,
    pickActivationDate: boolean
  },
  captchaValid: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    errors: { type: Array, required: true },
    products: { type: Array, required: true },
    service: { type: Object, required: true },
    isPromoValid: { type: Boolean, required: true },
    promotionDiscounts: { type: Array, required: true },
    validPromotion: { type: null, required: false },
    suggestedPromotion: { type: null, required: false }
  },
  emits: ["onEnterPromoCode", "onConfirmOrder", "onContactInformation"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onEnterPromoCode', promoCodeInput?: string): void,
  (e: 'onConfirmOrder', formData: ConfirmOrderData, done: () => void): void,
  (e: 'onContactInformation', contactInformation: ContactInformation): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  errors: string[],
  products: Product[],
  service: Service,
  isPromoValid: boolean,
  promotionDiscounts: Array<Action>,
  validPromotion?: Promotion,
  suggestedPromotion?: Promotion
}
const orderService = injectStrict<OrderServiceInterface>('OrderServiceInterface');
const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');



const delayedNdc = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'DELAYED-NDC');
});

const yearOff = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'YEAR-OFF');
});

const monthOff = computed(() => {
  let plan = '';
  if (props.products.length > 0 && props.products.filter(pr => pr.type === 'internet').length > 0) {
    plan = props.products.filter(pr => pr.type === 'internet')[0].id;
  }
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'ONE-OFF' && (discount.applicableTo.length <= 0 || (discount.applicableTo.length > 0 && discount.applicableTo.includes(plan))));
});

const preInstalledRouter = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'FREE-ROUTER-INSTALLED');
});

const account = computed(() => {
  return store.state.account;
});

const salesPerson = computed(() => {
  return store.state.salesPerson;
});

const isPromoValid = computed(() => {
  return props.isPromoValid;
});

const voiceProduct = computed(() => {
  return props.products.filter(product => product.type === 'voice').length > 0;
});

const today = computed((): string => {
  return format(new Date(), 'yyyy-MM-dd');
});

const tomorrow = computed((): string => {
  return format(addDays(1, new Date()), 'yyyy-MM-dd');
});

const formData : ConfirmOrderData = reactive({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: null,
  companyName: '',
  abnNumber: null,
  ccNumber: null,
  ccName: '',
  ccExpiry: '',
  ccCvc: '',
  ddAccountNumber: '',
  ddAccountBsb: '',
  token: '',
  crmId: null,
  activationDate: today.value,
  formSelectionOptions: {
    businessAccount: false,
    paymentMethod: 'cc',
    confirmAddressToggle: false,
    termsAgreementToggle: false,
    csgWaiverToggle: false,
    toggleExpandCsgWaiver: false,
    ddAgreementToggle: false,
    pickActivationDate: false
  },
  captchaValid: false
});

const { handleReset } = useRecaptcha();

const handleWidgetId = (widgetId: number) => {
  handleReset(widgetId);
};
const handleErrorCalback = () => {
  formData.captchaValid = false;
};
const handleExpiredCallback = () => {
  formData.captchaValid = false;
};
const handleLoadCallback = (response: unknown) => {
  if (response) {
    formData.captchaValid = true;
  }
};

const promoCode = ref(props.suggestedPromotion?.code);

function promoCodeClickHandler () {
  let promoCodeUppercase;
  if (promoCode.value) {
    promoCodeUppercase = promoCode.value.toUpperCase();
  }
  emit('onEnterPromoCode', promoCodeUppercase);
}

const contactInformation : ContactInformation = reactive({
  firstName: null,
  lastName: null,
  phoneNumber: null,
  email: ''
});

const pickActivationDate = ref(() => formData.formSelectionOptions.pickActivationDate);
const businessAccount = ref(() => formData.formSelectionOptions.businessAccount);
const paymentMethodRequiredCc = ref(() => formData.formSelectionOptions.paymentMethod === 'cc' && (!salesPerson.value));
const paymentMethodRequiredDd = ref(() => formData.formSelectionOptions.paymentMethod === 'dd' && (!salesPerson.value));

const rules = {
  firstName: {
    required: helpers.withMessage('Please enter a firstname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  lastName: {
    required: helpers.withMessage('Please enter a lastname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  email: {
    required: helpers.withMessage('Please enter an email address', required),
    email: helpers.withMessage('Please enter a valid email address', email)
  },
  phoneNumber: {
    required: helpers.withMessage('This field cannot be empty', required),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(10)),
    maxLengthValue: helpers.withMessage('Please enter a phone number with 10 digits', maxLength(10))
  },
  companyName: {
    requiredIf: helpers.withMessage('Please enter a company name', requiredIf(businessAccount.value)),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(1)),
    maxLengthValue: helpers.withMessage('Please enter less than 50 chars', maxLength(50)),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation)
  },
  abnNumber: {
    requiredIf: helpers.withMessage('Please enter an ABN number', requiredIf(businessAccount.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 11 digit ABN number', minLength(11)),
    maxLength: helpers.withMessage('Please enter a 11 digit ABN number', maxLength(11))
  },
  ccNumber: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    ccValidation: helpers.withMessage('Please enter a valid credit card number', ccValidations.numberValidation)
  },
  ccName: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(40))
  },
  ccExpiry: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccExpiryValidation: helpers.withMessage('Please enter a valid MM/YY expiry', ccValidations.expiryValidation)
  },
  ccCvc: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccCvcValidation: helpers.withMessage('Please enter a valid CVC number', ccValidations.cvcValidation)
  },
  ddAccountNumber: {
    requiredIf: helpers.withMessage('Please enter an account number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a valid account number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a valid account number', maxLength(10))
  },
  ddAccountBsb: {
    requiredIf: helpers.withMessage('Please enter a BSB number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 6 digit BSB number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a 6 digit BSB number', maxLength(6))
  },
  activationDate: {
    requiredIf: helpers.withMessage('Please select a date the service should be activated', requiredIf(pickActivationDate.value))
  }
};
const v$ = useVuelidate(rules, formData);

const directDebitFormFields = computed(() => {
  return formData.formSelectionOptions.paymentMethod !== 'cc';
});

// eslint-disable-next-line func-call-spacing


const confirmAddressError = ref(false);
const termsAgreementError = ref(false);
const ddAgreementError = ref(false);
const csgWaiverError = ref(false);
const captchaError = ref(false);

const handleConfirmOrder = async (done: () => void) => {
  const formValidated = await v$.value.$validate();

  if (!formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = true;
  if (!formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = true;
  if (!formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = true;
  if (voiceProduct.value && !formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = true;
  if (!formData.captchaValid) captchaError.value = true;

  if (!voiceProduct.value) {
    if (formValidated && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !captchaError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  } else if (voiceProduct.value) {
    if (formValidated && voiceProduct.value && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !csgWaiverError.value && !captchaError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  }
};

const handleClickConfirmAddress = () => {
  if (formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = false;
};

const handleClickTermsAgreement = () => {
  if (formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = false;
};

const handleClickCsgWaiver = () => {
  if (formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = false;
};

const handleClickDdAgreement = () => {
  if (formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = false;
};

const handleClickBusinessAccount = () => {
  formData.companyName = '';
  formData.abnNumber = null;
};

const handleActivationDate = () => {
  if (formData.formSelectionOptions.pickActivationDate) {
    formData.activationDate = tomorrow.value;
  } else {
    formData.activationDate = today.value;
  }
};

const handleFirstNameBlur = () => {
  v$.value.firstName.$touch();

  if (!v$.value.firstName.$error) {
    contactInformation.firstName = formData.firstName;
  } else {
    contactInformation.firstName = null;
  }
};

const handleLastNameBlur = () => {
  v$.value.lastName.$touch();

  if (!v$.value.lastName.$error) {
    contactInformation.lastName = formData.lastName;
  } else {
    contactInformation.lastName = null;
  }
};

const handlePhoneBlur = () => {
  v$.value.phoneNumber.$touch();

  if (!v$.value.phoneNumber.$error) {
    contactInformation.phoneNumber = formData.phoneNumber;
  } else {
    contactInformation.phoneNumber = null;
  }
};

const handleEmailBlur = () => {
  v$.value.email.$touch();

  if (!v$.value.email.$error) {
    contactInformation.email = formData.email;
  } else {
    contactInformation.email = null;
  }
};

const toggleExpandCsgWaiver = () => {
  formData.formSelectionOptions.toggleExpandCsgWaiver = !formData.formSelectionOptions.toggleExpandCsgWaiver;
};

watch(
  contactInformation,
  (newContactInformation) => {
    if (newContactInformation.email) {
      emit('onContactInformation', newContactInformation);
    }
  }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "first-name",
                    name: "first-name",
                    autocomplete: "given-name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(formData).firstName = $event)),
                    onBlur: handleFirstNameBlur,
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                  }, null, 544), [
                    [_vModelText, _unref(formData).firstName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "firstName-error"
                  }, [
                    (error.$property === 'firstName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "last-name",
                    name: "last-name",
                    autocomplete: "family-name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(formData).lastName = $event)),
                    onBlur: handleLastNameBlur,
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                  }, null, 544), [
                    [_vModelText, _unref(formData).lastName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "lastName-error"
                  }, [
                    (error.$property === 'lastName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email-address",
                  name: "email-address",
                  autocomplete: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(formData).email = $event)),
                  onBlur: handleEmailBlur,
                  class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                }, null, 544), [
                  [_vModelText, _unref(formData).email]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "email-error"
                }, [
                  (error.$property === 'email')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "phone",
                  id: "phone",
                  autocomplete: "tel",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(formData).phoneNumber = $event)),
                  onBlur: handlePhoneBlur,
                  class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                }, null, 544), [
                  [_vModelText, _unref(formData).phoneNumber]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "phoneNumber-error"
                }, [
                  (error.$property === 'phoneNumber')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("select", {
                    id: "activationDateOption",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_unref(formData).formSelectionOptions.pickActivationDate = $event)),
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm",
                    onChange: handleActivationDate
                  }, _hoisted_27, 544), [
                    [_vModelSelect, _unref(formData).formSelectionOptions.pickActivationDate]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    min: _unref(tomorrow),
                    name: "activationDate",
                    id: "activationDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(formData).activationDate = $event)),
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(v$).activationDate.$touch && _unref(v$).activationDate.$touch(...args))),
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                  }, null, 40, _hoisted_31), [
                    [_vModelText, _unref(formData).activationDate]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "activationDate-error"
                  }, [
                    (error.$property === 'activationDate')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, _unref(formData).formSelectionOptions.pickActivationDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  onClick: handleClickBusinessAccount,
                  id: "same-as-shipping",
                  name: "same-as-shipping",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(formData).formSelectionOptions.businessAccount = $event)),
                  class: "h-4 w-4 border-gray-200 rounded text-brand-accent focus:ring-brand-accent"
                }, null, 512), [
                  [_vModelCheckbox, _unref(formData).formSelectionOptions.businessAccount]
                ])
              ]),
              _hoisted_35
            ]),
            (_unref(formData).formSelectionOptions.businessAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _hoisted_37,
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "company-name",
                        name: "company-name",
                        autocomplete: "organization",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_unref(formData).companyName = $event)),
                        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(v$).companyName.$touch && _unref(v$).companyName.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).companyName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "companyName-error"
                      }, [
                        (error.$property === 'companyName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_40,
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "abn-number",
                        name: "abn-number",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_unref(formData).abnNumber = $event)),
                        onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(v$).abnNumber.$touch && _unref(v$).abnNumber.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).abnNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "abnNumber-error"
                      }, [
                        (error.$property === 'abnNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            (!_unref(directDebitFormFields))
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "card-number",
                        name: "card-number",
                        autocomplete: "cc-number",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_unref(formData).ccNumber = $event)),
                        onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(v$).ccNumber.$touch && _unref(v$).ccNumber.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ccNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccNumber-error"
                      }, [
                        (error.$property === 'ccNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "name-on-card",
                        name: "name-on-card",
                        autocomplete: "cc-name",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_unref(formData).ccName = $event)),
                        onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(v$).ccName.$touch && _unref(v$).ccName.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ccName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccName-error"
                      }, [
                        (error.$property === 'ccName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "expiration-date",
                        id: "expiration-date",
                        autocomplete: "cc-exp",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_unref(formData).ccExpiry = $event)),
                        onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(v$).ccExpiry.$touch && _unref(v$).ccExpiry.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ccExpiry]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccExpiry-error"
                      }, [
                        (error.$property === 'ccExpiry')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "cvc",
                        id: "cvc",
                        autocomplete: "cc-csc",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_unref(formData).ccCvc = $event)),
                        onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(v$).ccCvc.$touch && _unref(v$).ccCvc.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ccCvc]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccCvc-error"
                      }, [
                        (error.$property === 'ccCvc')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(directDebitFormFields))
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "account-number",
                        id: "account-number",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_unref(formData).ddAccountNumber = $event)),
                        onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountNumber.$touch && _unref(v$).ddAccountNumber.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ddAccountNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountNumber-error"
                      }, [
                        (error.$property === 'ddAccountNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "bsb",
                        id: "bsb",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_unref(formData).ddAccountBsb = $event)),
                        onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, _unref(formData).ddAccountBsb]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountBsb-error"
                      }, [
                        (error.$property === 'ddAccountBsb')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("p", _hoisted_78, _toDisplayString(__props.service.address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickConfirmAddress,
                      modelValue: _unref(formData).formSelectionOptions.confirmAddressToggle,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_unref(formData).formSelectionOptions.confirmAddressToggle = $event)),
                      class: _normalizeClass([
                        (_unref(formData).formSelectionOptions.confirmAddressToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (confirmAddressError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_80,
                        _createElementVNode("span", {
                          class: _normalizeClass([_unref(formData).formSelectionOptions.confirmAddressToggle ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.confirmAddressToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_82, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.confirmAddressToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_84, 2)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/terms-and-conditions.pdf`,
                      target: "_blank",
                      class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250"
                    }, "Terms and Conditions.", 8, _hoisted_88)
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickTermsAgreement,
                      modelValue: _unref(formData).formSelectionOptions.termsAgreementToggle,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_unref(formData).formSelectionOptions.termsAgreementToggle = $event)),
                      class: _normalizeClass([
                        (_unref(formData).formSelectionOptions.termsAgreementToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (termsAgreementError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_90,
                        _createElementVNode("span", {
                          class: _normalizeClass([_unref(formData).formSelectionOptions.termsAgreementToggle ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.termsAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_92, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.termsAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_94, 2)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ])
                ]),
                (_unref(voiceProduct))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                      _createElementVNode("div", {
                        class: "text-sm font-light",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (toggleExpandCsgWaiver()))
                      }, [
                        _hoisted_96,
                        _hoisted_97,
                        (_unref(formData).formSelectionOptions.csgWaiverToggle && _unref(salesPerson))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_98, [
                              _hoisted_99,
                              _createElementVNode("a", {
                                class: "text-red-600",
                                href: _ctx.$router.resolve({ name: 'csg-waiver-script' }).href,
                                target: "_blank"
                              }, "CSG Waiver Script", 8, _hoisted_100)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _createVNode(_unref(Switch), {
                          onClick: handleClickCsgWaiver,
                          modelValue: _unref(formData).formSelectionOptions.csgWaiverToggle,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_unref(formData).formSelectionOptions.csgWaiverToggle = $event)),
                          class: _normalizeClass([
                        (_unref(formData).formSelectionOptions.csgWaiverToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (csgWaiverError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_102,
                            _createElementVNode("span", {
                              class: _normalizeClass([_unref(formData).formSelectionOptions.csgWaiverToggle ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass([_unref(formData).formSelectionOptions.csgWaiverToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                                "aria-hidden": "true"
                              }, _hoisted_104, 2),
                              _createElementVNode("span", {
                                class: _normalizeClass([_unref(formData).formSelectionOptions.csgWaiverToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                                "aria-hidden": "true"
                              }, _hoisted_106, 2)
                            ], 2)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "class"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(voiceProduct) && _unref(formData).formSelectionOptions.toggleExpandCsgWaiver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                      _createElementVNode("div", _hoisted_108, [
                        _createVNode(CsgTerms, {
                          firstName: _unref(contactInformation).firstName,
                          lastName: _unref(contactInformation).lastName,
                          brand: _unref(brandService).getTitle(),
                          phone: _unref(brandService).getSupportPhoneNumber(),
                          address: _unref(brandService).getAddress()
                        }, null, 8, ["firstName", "lastName", "brand", "phone", "address"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/direct-debit-service-request-agreement.pdf`,
                      target: "_blank",
                      class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250"
                    }, "Direct Debit Service Request Agreement.", 8, _hoisted_112)
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickDdAgreement,
                      modelValue: _unref(formData).formSelectionOptions.ddAgreementToggle,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_unref(formData).formSelectionOptions.ddAgreementToggle = $event)),
                      class: _normalizeClass([
                        (_unref(formData).formSelectionOptions.ddAgreementToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (ddAgreementError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_114,
                        _createElementVNode("span", {
                          class: _normalizeClass([_unref(formData).formSelectionOptions.ddAgreementToggle ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.ddAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_116, 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([_unref(formData).formSelectionOptions.ddAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _hoisted_118, 2)
                        ], 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class"])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_119,
          _createElementVNode("div", _hoisted_120, [
            _hoisted_121,
            _createElementVNode("div", _hoisted_122, [
              _hoisted_123,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "promoCode",
                id: "promoCode",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (promoCode.value = $event)),
                onBlur: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                class: "uppercase border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
              }, null, 544), [
                [_vModelText, promoCode.value]
              ]),
              _createElementVNode("button", {
                onClick: promoCodeClickHandler,
                type: "button",
                class: "inline-flex items-center ml-2 px-3.5 py-2.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent"
              }, "Apply"),
              (_unref(isPromoValid))
                ? (_openBlock(), _createElementBlock("p", _hoisted_124, "Promo code " + _toDisplayString(__props.validPromotion?.code) + " applied!", 1))
                : _createCommentVNode("", true),
              (!_unref(isPromoValid) && promoCode.value && promoCode.value.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_125, "Promo code invalid!"))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_126,
          _createElementVNode("div", _hoisted_127, [
            _hoisted_128,
            _createElementVNode("ul", _hoisted_129, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: product.name,
                  class: "flex py-6 px-4 sm:px-6"
                }, [
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("h4", _hoisted_132, _toDisplayString(product.name), 1),
                      _createElementVNode("p", _hoisted_133, _toDisplayString(product.description), 1),
                      (product.type !== 'hardware')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_134, " Monthly "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("p", {
                        class: _normalizeClass(['text-sm font-medium', _unref(isPromoValid) && product.discounted ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                      (_unref(isPromoValid) && product.discounted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 512)), [
                  [_vShow, product.type === 'internet' || product.type === 'voice' || product.type === 'hardware']
                ])
              }), 128))
            ]),
            _createElementVNode("dl", _hoisted_139, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between px-4 sm:px-6"
                }, [
                  _hoisted_140,
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      (product.price >= 0 && !_unref(isPromoValid) || !product.displayDiscount)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 0,
                            class: _normalizeClass(['text-sm font-medium', _unref(isPromoValid) && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                          }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      (_unref(isPromoValid) && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_144, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 512)), [
                  [_vShow, product.code === 'ACTIVATION-FEE']
                ])
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between border-t border-gray-200 pt-6 px-4 sm:px-6"
                }, [
                  _createElementVNode("dt", _hoisted_145, [
                    _hoisted_146,
                    _createElementVNode("div", _hoisted_147, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(InformationCircleIcon)), {
                        class: "h-6 w-6 text-brand-button-text",
                        "aria-hidden": "true"
                      })),
                      _hoisted_148
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("div", _hoisted_150, [
                      _createElementVNode("dd", {
                        class: _normalizeClass(['text-sm font-medium', _unref(isPromoValid) && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_151, [
                      (_unref(isPromoValid) && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_152, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 512)), [
                  [_vShow, product.code === 'NDC']
                ])
              }), 128)),
              (_unref(delayedNdc))
                ? (_openBlock(), _createElementBlock("div", _hoisted_153, _hoisted_155))
                : _createCommentVNode("", true),
              (_unref(yearOff))
                ? (_openBlock(), _createElementBlock("div", _hoisted_156, _hoisted_158))
                : _createCommentVNode("", true),
              (_unref(monthOff))
                ? (_openBlock(), _createElementBlock("div", _hoisted_159, _hoisted_161))
                : _createCommentVNode("", true),
              (_unref(preInstalledRouter))
                ? (_openBlock(), _createElementBlock("div", _hoisted_162, _hoisted_164))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_165, [
                _hoisted_166,
                _createElementVNode("dd", _hoisted_167, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateFirstInvoiceTotal(__props.products, _unref(isPromoValid), __props.validPromotion))), 1)
              ]),
              _createElementVNode("div", _hoisted_168, [
                _createElementVNode("dt", _hoisted_169, [
                  _hoisted_170,
                  _createElementVNode("span", _hoisted_171, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateMinimumCost(__props.products, _unref(isPromoValid), __props.validPromotion))), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _createElementVNode("div", _hoisted_173, [
                _createVNode(_unref(RecaptchaV2), {
                  onWidgetId: handleWidgetId,
                  onErrorCallback: handleErrorCalback,
                  onExpiredCallback: handleExpiredCallback,
                  onLoadCallback: handleLoadCallback
                })
              ]),
              _createVNode(AsyncButton, {
                onOnClick: handleConfirmOrder,
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _hoisted_174
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                (confirmAddressError.value || termsAgreementError.value || ddAgreementError.value || csgWaiverError.value || captchaError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_175, " Please confirm your details and tick the required fields "))
                  : _createCommentVNode("", true),
                (_unref(v$).$error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_176, " Please fill out all required form fields "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: error,
                    class: "mt-4 text-sm text-red-600"
                  }, _toDisplayString(error), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})